<ng-template #ModalCustomDate let-modal>
  <div class="flex justify-between align-center p-2">
    <h5 class="modal-title" id="myModalLabel160">
      {{ "CUSTOM_SHIP_DATES.TITLE" | translate }}
    </h5>
    <button
      type="button"
      class="close"
      (click)="modal.dismiss('actionCanceled')"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="d-flex pl-3 pr-3 align-items-center justify-content-center">
    <app-search-bar
      class="flex-1 w-100"
      [settings]="searchSettings"
      [customActionsTemplate]="viewModeTemplate"
      (search)="onSearch($event)"
    >
    </app-search-bar>

    <div class="btn-group margin-left-small">
      <div
        ngbDropdown
        container="body"
        [placement]="'bottom-right'"
        #bulkDateDropdownToggle="ngbDropdown"
      >
        <button
          ngbDropdownToggle
          class="btn btn-primary"
          type="button"
          [disabled]="itemsSelected.length === 0"
          rippleEffect
        >
          {{
            "CUSTOM_SHIP_DATES.BULK_PERSONALIZED_DATE"
              | translate: { numberOfItems: itemsSelected.length }
          }}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
          <div class="px-1">
            <label>{{ "CUSTOM_SHIP_DATES.CUSTOM_DATE" | translate }}</label>
            <app-custom-date-time-picker
              [dateTime]="null"
              [min]="minBulkDate"
              [max]="maxStoreCustomDate"
              [disableClearBtn]="true"
              [dateNotSelectableCustomText]="
                'CUSTOM_SHIP_DATES.DATE_NOT_SELECTABLE'
              "
              (dateTimeEmit)="
                bulkDateDropdownToggle.close(); onBulkAddCustomDate($event)
              "
            >
            </app-custom-date-time-picker>
          </div>
          <div class="dropdown-divider mt-1"></div>
          <a ngbDropdownItem (click)="onBulkCustomStockDate()">
            <span data-feather="plus"></span>
            {{ "VARIANT_GRID.ADD_DELIVERY_WITH_STOCK" | translate }}
          </a>
          <a
            ngbDropdownItem
            class="text-danger"
            (click)="onBulkRemoveCustomDate()"
          >
            <span data-feather="trash"></span>
            {{ "CUSTOM_SHIP_DATES.REMOVE_ALL_CUSTOM_DATES" | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>

  <div
    class="d-flex justify-content-between align-items-center select-all-container mt-1 mx-2"
  >
    <div class="d-flex align-items-center f-gap-small">
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          [checked]="isSelectedAll"
          (change)="$event.target['checked'] ? onSelectAll() : onUnselectAll()"
          id="selectAll"
        />
        <label class="custom-control-label" for="selectAll">{{
          "GENERIC_LABEL.SELECT_ALL" | translate
        }}</label>
      </div>

      @if (viewMode !== ViewMode.All) {
        <div class="btn-group">
          @if (!accordionIsExpanded) {
            <button
              type="button"
              class="btn btn-link margin-left-small text-black"
              (click)="onExpandCollapseAll()"
              rippleEffect
            >
              <span data-feather="chevron-down"></span>
              <span>{{ "COMMON.EXPAND_ALL" | translate }}</span>
            </button>
          }
          @if (accordionIsExpanded) {
            <button
              type="button"
              class="btn btn-link margin-left-small text-black"
              (click)="onExpandCollapseAll()"
              rippleEffect
            >
              <span data-feather="chevron-up"></span>
              <span>{{ "COMMON.COLLAPSE_ALL" | translate }}</span>
            </button>
          }
        </div>
      }
    </div>

    <div ngbDropdown container="body" [placement]="'bottom-right'">
      <button
        ngbDropdownToggle
        class="btn btn-flat-primary"
        type="button"
        [disabled]="itemsSelected.length === 0"
        rippleEffect
      >
        <span data-feather="list"></span>
        {{
          "CUSTOM_SHIP_DATES.VIEW_SELECTION"
            | translate: { n: itemsSelected.length }
        }}
      </button>
      <div
        ngbDropdownMenu
        style="max-height: 300px; overflow-y: auto; min-width: 320px"
      >
        @for (
          ctrl of orderItemsFormCustomDate.controls;
          track ctrl;
          let i = $index
        ) {
          @if (ctrl.get("isChecked").value) {
            <div
              class="d-flex align-items-center px-2 py-1 f-gap-small border-bottom"
            >
              <img
                [src]="ctrl.get('img').value"
                style="
                  width: 36px;
                  height: 36px;
                  object-fit: cover;
                  flex-shrink: 0;
                "
              />
              <span class="flex-grow-1 truncate" style="font-size: 0.85rem">
                {{ ctrl.get("productCode").value }} /
                {{ ctrl.get("color").value }} / {{ ctrl.get("size").value }}
              </span>
              <button
                type="button"
                class="btn btn-icon btn-sm btn-flat-danger"
                (click)="onUnselectItem(i)"
                rippleEffect
              >
                <span data-feather="x"></span>
              </button>
            </div>
          }
        }
      </div>
    </div>
  </div>

  <div class="modal-body">
    <app-loader [loaderId]="loaderId" [fullPage]="false">
      @if (viewMode === ViewMode.All) {
        <ng-container *ngTemplateOutlet="allViewModeTemplate"></ng-container>
      }
      @if (viewMode === ViewMode.originalDate) {
        <ng-container
          *ngTemplateOutlet="originalDateViewModeTemplate"
        ></ng-container>
      }
      @if (viewMode === ViewMode.customDate) {
        <ng-container
          *ngTemplateOutlet="customDateViewModeTemplate"
        ></ng-container>
      }
      @if (viewMode === ViewMode.styleCode) {
        <ng-container
          *ngTemplateOutlet="styleCodeViewModeTemplate"
        ></ng-container>
      }
    </app-loader>
  </div>
  <div class="modal-footer">
    @if (showBackButton) {
      <button
        type="button"
        class="btn btn-outline-primary"
        (click)="modal.dismiss('actionCanceled')"
        rippleEffect
      >
        <span data-feather="x"></span>
        {{ "GENERIC_LABEL.BACK" | translate }}
      </button>
    }
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="orderItemsFormCustomDate.invalid || !isChanged || isSaving()"
      (click)="onSaveCustomDates()"
      rippleEffect
    >
      <span data-feather="save"></span>
      {{ (!orderId ? "GENERIC_LABEL.ADD" : "GENERIC_LABEL.APPLY") | translate }}
    </button>
  </div>
</ng-template>

<ng-template #allViewModeTemplate>
  @if (isDateOverMaxDate) {
    <p class="text-danger m-0 margin-top-small">
      {{ "CUSTOM_SHIP_DATES.DATE_OVER_MAX_DATE" | translate }}
    </p>
  }
  @if (selectedRequestedDeliveryDatesAreOverMaxDate) {
    <p class="text-danger m-0 margin-top-small">
      {{ "CUSTOM_SHIP_DATES.REQUESTED_DATE_OVER_MAX_DATE" | translate }}
    </p>
  }

  <app-new-order-item-accordion-list
    [orderItemsFormCustomDate]="orderItemsFormCustomDate"
    [supportsSplitDelivery]="supportsSplitDelivery"
    [showStockQty]="showStockQty"
    [maxStoreCustomDate]="maxStoreCustomDate"
    [viewMode]="viewMode"
    [itemsSelected]="itemsSelected"
    [minBulkDate]="minBulkDate"
    [componentId]="componentId"
    [expandCollapse$]="accordionToggle$"
    (dateAdded)="addCustomDate($event.orderItemIndex, $event.customDate)"
    (stockDateAdded)="addCustomStockDate($event)"
    (customDateCleared)="onClearItemCustomDates($event)"
    (dateRemoved)="
      removeCustomDate($event.orderItemIndex, $event.customDateIndex)
    "
    (dateTimeChanged)="onDateTimeEmit($event.ev, $event.form)"
  >
  </app-new-order-item-accordion-list>
</ng-template>

<ng-template #originalDateViewModeTemplate>
  @if (isDateOverMaxDate) {
    <p class="text-danger m-0 margin-top-small">
      {{ "CUSTOM_SHIP_DATES.DATE_OVER_MAX_DATE" | translate }}
    </p>
  }
  @if (selectedRequestedDeliveryDatesAreOverMaxDate) {
    <p class="text-danger m-0 margin-top-small">
      {{ "CUSTOM_SHIP_DATES.REQUESTED_DATE_OVER_MAX_DATE" | translate }}
    </p>
  }
  <app-new-order-item-grouped-by-original-date
    [groups]="originalDateGroups"
    [orderItemsFormCustomDate]="orderItemsFormCustomDate"
    [supportsSplitDelivery]="supportsSplitDelivery"
    [showStockQty]="showStockQty"
    [maxStoreCustomDate]="maxStoreCustomDate"
    [componentId]="componentId"
    [expandCollapse$]="accordionToggle$"
    (dateAdded)="addCustomDate($event.orderItemIndex, $event.customDate)"
    (stockDateAdded)="addCustomStockDate($event)"
    (customDateCleared)="onClearItemCustomDates($event)"
    (dateRemoved)="
      removeCustomDate($event.orderItemIndex, $event.customDateIndex)
    "
    (dateTimeChanged)="onDateTimeEmit($event.ev, $event.form)"
  >
  </app-new-order-item-grouped-by-original-date>
</ng-template>

<ng-template #customDateViewModeTemplate>
  @if (isDateOverMaxDate) {
    <p class="text-danger m-0 margin-top-small">
      {{ "CUSTOM_SHIP_DATES.DATE_OVER_MAX_DATE" | translate }}
    </p>
  }
  @if (selectedRequestedDeliveryDatesAreOverMaxDate) {
    <p class="text-danger m-0 margin-top-small">
      {{ "CUSTOM_SHIP_DATES.REQUESTED_DATE_OVER_MAX_DATE" | translate }}
    </p>
  }
  <app-new-order-item-grouped-by-custom-date
    [groups]="customDateGroups"
    [orderItemsFormCustomDate]="orderItemsFormCustomDate"
    [supportsSplitDelivery]="supportsSplitDelivery"
    [showStockQty]="showStockQty"
    [maxStoreCustomDate]="maxStoreCustomDate"
    [componentId]="componentId"
    [expandCollapse$]="accordionToggle$"
    (dateAdded)="addCustomDate($event.orderItemIndex, $event.customDate)"
    (stockDateAdded)="addCustomStockDate($event)"
    (customDateCleared)="onClearItemCustomDates($event)"
    (dateRemoved)="
      removeCustomDate($event.orderItemIndex, $event.customDateIndex)
    "
    (dateTimeChanged)="onDateTimeEmit($event.ev, $event.form)"
  >
  </app-new-order-item-grouped-by-custom-date>
</ng-template>

<ng-template #styleCodeViewModeTemplate>
  @if (isDateOverMaxDate) {
    <p class="text-danger m-0 margin-top-small">
      {{ "CUSTOM_SHIP_DATES.DATE_OVER_MAX_DATE" | translate }}
    </p>
  }
  @if (selectedRequestedDeliveryDatesAreOverMaxDate) {
    <p class="text-danger m-0 margin-top-small">
      {{ "CUSTOM_SHIP_DATES.REQUESTED_DATE_OVER_MAX_DATE" | translate }}
    </p>
  }
  <app-new-order-item-grouped-by-style-code
    [groups]="styleCodeGroups"
    [orderItemsFormCustomDate]="orderItemsFormCustomDate"
    [supportsSplitDelivery]="supportsSplitDelivery"
    [showStockQty]="showStockQty"
    [maxStoreCustomDate]="maxStoreCustomDate"
    [componentId]="componentId"
    [expandCollapse$]="accordionToggle$"
    (dateAdded)="addCustomDate($event.orderItemIndex, $event.customDate)"
    (stockDateAdded)="addCustomStockDate($event)"
    (customDateCleared)="onClearItemCustomDates($event)"
    (dateRemoved)="
      removeCustomDate($event.orderItemIndex, $event.customDateIndex)
    "
    (dateTimeChanged)="onDateTimeEmit($event.ev, $event.form)"
  >
  </app-new-order-item-grouped-by-style-code>
</ng-template>

<ng-template #viewModeTemplate>
  <div class="flex align-center" placement="bottom-right">
    <div class="btn-group" role="group">
      <input
        type="radio"
        class="btn-check"
        name="oiViewMode"
        id="oiViewAll"
        [(ngModel)]="viewMode"
        [value]="ViewMode.All"
        (ngModelChange)="onChangeViewMode($event)"
      />
      <label class="btn btn-outline-primary" for="oiViewAll">
        {{ "STATUS.ALL" | translate }}
      </label>
      <input
        type="radio"
        class="btn-check"
        name="oiViewMode"
        id="oiViewByDate"
        [(ngModel)]="viewMode"
        [value]="ViewMode.originalDate"
        (ngModelChange)="onChangeViewMode($event)"
      />
      <label class="btn btn-outline-primary" for="oiViewByDate">
        {{ "MENU.BY_DATE" | translate }}
      </label>
      <input
        type="radio"
        class="btn-check"
        name="oiViewMode"
        id="oiViewByStyle"
        [(ngModel)]="viewMode"
        [value]="ViewMode.styleCode"
        (ngModelChange)="onChangeViewMode($event)"
      />
      <label class="btn btn-outline-primary" for="oiViewByStyle" rippleEffect>
        {{ "MENU.STYLE_CODE" | translate }}
      </label>
    </div>
  </div>
</ng-template>
